// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "main.nomodule." + {"174":"e6639535e049e4ada528","941":"0c400ef41643da45ac38"}[chunkId] + ".js";
};